import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";
import parseToTimestamp from "shared/utils/parseToTimestamp";
export const fetchProgramCase = createAsyncThunk(
    'contract/fetchProgramCase',
    async ({ programID, sortArray }: {
        programID: string,
        sortArray: string[] | [],
    }, { rejectWithValue }) => {
        try {
            const requestBody = {
                "Limit": 100000000000,
                "Offset": 0,
                "ProgramID": programID,
                "SortableColumns": sortArray
            };
            const response = await getRequest(requestBody, 'dms-hr', 'getProgramCase', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { case: data.Program.Hospitals, hospitalCount: data.Program.HospitalCount, printName: data.Program.PrintName, fetchTime: parseToTimestamp(new Date()), programID };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

interface IFilters {
    Field: string;
    ComparisonType: string;
    Value: string[];
}
export const fetchProgramDownload = createAsyncThunk(
    'contract/fetchProgramDownload',
    async ({ ProgramID, DataType, Filters }: {
        ProgramID: string,
        DataType: string,
        Filters: IFilters[];
    }, { rejectWithValue }) => {
        try {
            const requestBody = {
                "ProgramID": ProgramID,
                "DataType": DataType,
                "Filters": Filters
            };

            const response = await getRequest(requestBody, 'dms-hr', 'downloadProgramFile', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { FileData: data.File.DataBase64, FileName: data.File.Name };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);